import { Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import FormFile from '../../atoms/FormFile/FormFile'
import QuantityHandler from '../../atoms/QuantityHandler/QuantityHandler'
import Button from '../../atoms/Button/Button'
import * as yup from 'yup'
import AutoComplete, { useAutocomplete } from '../../molecules/AutoComplete/AutoComplete'
import { api } from '../../../utils'
import { PROFILOAZIENDA, RICHIESTATAYLORMADE } from '../../../utils/endpoint'
import { useSelector } from 'react-redux'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import { useRouter } from 'next/router'
import useTrans from '../../../hooks/useTrans'
import { Trans } from '../../atoms'
import usePrivacy from '../../../hooks/usePrivacy'

const validationSchema = (t) =>
  yup.object().shape({
    email: yup
      .string()
      .email(t("L'email deve essere valida"))
      .required(t('Questo campo è obbligatorio'))
      .nullable(),
    telefono: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    nome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    cognome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
    prezzo_target: yup.number().typeError(t('Questo campo deve essere numerico')).nullable(),
  })

const FormTailorMade = () => {
  const { utente } = useSelector((state) => state?.utente)
  const [LogoFile, setLogoFile] = useState()
  const [items, setItems] = useState([])
  const [datiAzienda, setDatiAzienda] = useState({})
  const { data, loading, error, fetchItems } = useAutocomplete()
  const router = useRouter()
  const t = useTrans()
  const { getUrlInformativaFromStore } = usePrivacy()
  const { service_gift } = useSelector((state) => state?.servicegift)

  useEffect(() => {
    api
      .get(PROFILOAZIENDA)
      .then((res) =>
        setDatiAzienda({
          id: res?.data?.id,
          azienda: res?.data?.ragione_sociale,
        })
      )
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {}, [items])
  return (
    <Formik
      enableReinitialize
      initialValues={{
        nome: utente?.nome,
        cognome: utente?.cognome,
        email: utente?.email,
        telefono: utente?.telefono,
        codice_prodotto: null,
        quantita: 0,
        descrizione_articolo: null,
        dimensione_articolo: null,
        materiale_articolo: null,
        tecnica_stampa: null,
        numero_colori: null,
        dimensione_logo: null,
        colore: null,
        logo: null,
        data_consegna: null,
        prezzo_target: null,
      }}
      validationSchema={validationSchema(t)}
      isInitialValid={false}
      onSubmit={(values, { resetForm }) => {
        let data = new FormData()
        data.append('anagrafica_azienda', utente?.anagrafica_azienda_codice)
        data.append('azienda', datiAzienda?.azienda)
        data.append('nome', values?.nome)
        data.append('cognome', values?.cognome)
        data.append('email', values?.email)
        data.append('telefono', values?.telefono)
        values?.descrizione_articolo &&
          data.append('descrizione_articolo', values?.descrizione_articolo)
        values?.codice_prodotto && data.append('codice_articolo', values?.codice_prodotto)
        values?.dimensione_articolo &&
          data.append('dimensione_articolo', values?.dimensione_articolo)
        values?.materiale_articolo && data.append('materiale_articolo', values?.materiale_articolo)
        values?.colore && data.append('colore_articolo', values?.colore)
        values?.tecnica_stampa && data.append('tecnica_stampa', values?.tecnica_stampa)
        values?.numero_colori && data.append('numero_colori', values?.numero_colori)
        values?.dimensione_logo && data.append('dimensioni_logo', values?.dimensione_logo)
        values?.quantita && data.append('quantita', values?.quantita)
        values?.data_consegna && data.append('data_consegna', values?.data_consegna)
        values?.prezzo_target && data.append('prezzo_target', values?.prezzo_target)
        data.append('lang', router.locale)
        LogoFile && data.append('file', LogoFile)

        api
          .post(RICHIESTATAYLORMADE, data, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Content-Disposition': 'attachment; filename=file_to_upload.file.name',
            },
          })
          .then((res) => {
            res.data.upload && alert(t('Errore caricamento immagine'))
            if (!res.data.upload) {
              router.push('/strumenti-servizi/tailor-made/success')
              resetForm()
            }
          })
          .catch((err) => {
            console.log(err)
            displayNotification('tailor_made_error', err?.message, 'error')
          })
      }}
    >
      {(props) => (
        <div className="step-tailor" style={{ marginTop: 50 }}>
          <p style={{ marginBottom: 15 }}>
            <Trans chiave="Compila il form per richiedere un ordine import" />
          </p>
          <div className="step-tailor__fieldsets">
            <FormField
              label={t('Nome')}
              status={
                props.touched?.nome && props.errors?.nome
                  ? 'error'
                  : props.touched?.nome && 'success'
              }
              errorMessage={props.errors?.nome}
            >
              <FormInput
                placeholder={t('Nome')}
                value={props.values?.nome}
                onBlur={props.handleBlur('nome')}
                onChange={props.handleChange('nome')}
              />
            </FormField>
            <FormField
              label={t('Cognome')}
              status={
                props.touched?.cognome && props.errors?.cognome
                  ? 'error'
                  : props.touched?.cognome && 'success'
              }
              errorMessage={props.errors?.cognome}
            >
              <FormInput
                placeholder={t('Nome e cognome')}
                value={props.values?.cognome}
                onBlur={props.handleBlur('cognome')}
                onChange={props.handleChange('cognome')}
              />
            </FormField>
          </div>
          <div className="step-tailor__fieldsets">
            <FormField
              label={t('E-Mail')}
              status={
                props.touched.email && props.errors.email
                  ? 'error'
                  : props.touched.email && 'success'
              }
              errorMessage={props.errors?.email}
            >
              <FormInput
                placeholder={t('E-Mail')}
                value={props.values?.email}
                onBlur={props.handleBlur('email')}
                onChange={props.handleChange('email')}
              />
            </FormField>
            <FormField
              label={t('Telefono')}
              status={
                props.touched?.telefono && props.errors?.telefono
                  ? 'error'
                  : props.touched?.telefono && 'success'
              }
              errorMessage={props.errors?.telefono}
            >
              <FormInput
                placeholder={t('Telefono')}
                value={props.values?.telefono}
                onBlur={props.handleBlur('telefono')}
                onChange={props.handleChange('telefono')}
              />
            </FormField>
          </div>

          <div className="step-tailor__fieldsets" style={{ marginTop: 25 }}>
            <div>
              {/* Serve per il css */}
              <AutoComplete
                async
                loading={loading}
                status={
                  props.touched.codice_prodotto
                    ? props.errors.codice_prodotto
                      ? 'error'
                      : props.touched.codice_prodotto && 'success'
                    : null
                }
                errorMessage={props.errors?.codice_prodotto}
                onBlur={props.handleBlur('codice_prodotto')}
                onChange={(value) => {
                  fetchItems(value)
                  props.setFieldValue('codice_prodotto', value)
                }}
                label={t('Codice prodotto')}
                placeholder={t('Inserisci Codice prodotto')}
                items={data?.map((item) => {
                  return {
                    value: item?.codice,
                  }
                })}
              />
            </div>
            <FormField label={t('Quantità')}>
              <QuantityHandler
                value={props.values?.quantita}
                inputDisabled={false}
                onValueChange={(newVal, action) => {
                  switch (action) {
                    case 'remove':
                    case 'add':
                      newVal >= 0 && props.setFieldValue('quantita', newVal)
                    case 'set':
                      props.setFieldValue('quantita', isNaN(newVal) ? 0 : newVal)
                  }
                }}
              />
            </FormField>
            <FormField label={t('Descrizione Articolo')}>
              <FormInput
                placeholder={t('inserisci descrizione articolo')}
                value={props.values?.descrizione_articolo}
                onBlur={props.handleBlur('descrizione_articolo')}
                onChange={props.handleChange('descrizione_articolo')}
              />
            </FormField>

            <FormField label={t('Dimensione articolo')}>
              <FormInput
                placeholder={t('inserisci dimensione articolo')}
                value={props.values?.dimensione_articolo}
                onBlur={props.handleBlur('dimensione_articolo')}
                onChange={props.handleChange('dimensione_articolo')}
              />
            </FormField>

            <FormField label={t('Materiale articolo')}>
              <FormInput
                placeholder={t('inserisci materiale articolo')}
                value={props.values?.materiale_articolo}
                onBlur={props.handleBlur('materiale_articolo')}
                onChange={props.handleChange('materiale_articolo')}
              />
            </FormField>

            <FormField
              label={t('Tecnica di stampa')}
              status={
                props.touched.colore && props.errors.colore
                  ? 'error'
                  : props.touched.colore && 'success'
              }
              errorMessage={props.errors?.colore}
            >
              <FormInput
                placeholder={t('Tecnica di Stampa')}
                value={props.values?.tecnica_stampa}
                onBlur={props.handleBlur('tecnica_stampa')}
                onChange={props.handleChange('tecnica_stampa')}
              />
            </FormField>

            <FormField label={t('Numero di colori')}>
              <FormInput
                placeholder={t('Numero di colori')}
                value={props.values?.numero_colori}
                onBlur={props.handleBlur('numero_colori')}
                onChange={props.handleChange('numero_colori')}
              />
            </FormField>

            <FormField label={t('Dimensioni Logo')}>
              <FormInput
                placeholder={t('Dimensioni logo')}
                value={props.values?.dimensione_logo}
                onBlur={props.handleBlur('dimensione_logo')}
                onChange={props.handleChange('dimensione_logo')}
              />
            </FormField>

            <FormField
              label={t('Colore (Specificare se pantone)')}
              errorMessage={props.errors?.colore}
            >
              <FormInput
                placeholder={t('Inserisci il codice pantone')}
                value={props.values.colore}
                onBlur={props.handleBlur('colore')}
                onChange={props.handleChange('colore')}
              />
            </FormField>
            <FormField label={t('Logo')}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormFile
                  filename={LogoFile?.name}
                  placeholder={t('Carica un logo')}
                  onChange={(e) => setLogoFile(e.target.files[0])}
                />{' '}
                {LogoFile && (
                  <img
                    style={{ marginLeft: 10, maxWidth: 60, maxHeight: 50 }}
                    className="posizione__image"
                    src={LogoFile ? URL.createObjectURL(LogoFile) : null}
                  />
                )}
              </div>
            </FormField>
          </div>

          <div className="step-tailor__fieldsets" style={{ marginTop: 25, marginBottom: 25 }}>
            <FormField label={t('Data di consegna richiesta')}>
              <FormInput
                placeholder={t('inserisci data di consegna richiesta')}
                value={props.values?.data_consegna}
                onBlur={props.handleBlur('data_consegna')}
                onChange={props.handleChange('data_consegna')}
              />
            </FormField>
            <FormField
              label={t('Prezzo target')}
              status={
                props.touched?.prezzo_target && props.errors?.prezzo_target
                  ? 'error'
                  : props.touched?.prezzo_target && 'success'
              }
              errorMessage={props.errors?.prezzo_target}
            >
              <FormInput
                placeholder={t('inserisci prezzo target')}
                value={props.values?.prezzo_target}
                onBlur={props.handleBlur('prezzo_target')}
                onChange={props.handleChange('prezzo_target')}
              />
            </FormField>
          </div>
          {!service_gift?.attivo && (
            <p className="registrazione__template__disclaimer" style={{ marginBottom: 16 }}>
              {t('Contattandoci, dichiari di aver letto e compreso')}{' '}
              <a
                target="_blank"
                style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                href={getUrlInformativaFromStore()}
              >
                {t("l'Informativa Privacy")}
              </a>
            </p>
          )}
          <Button
            label={t('Richiedi ordine')}
            variant="primary"
            disabled={props.isValid ? false : true}
            type="submit"
            onClick={() => props.handleSubmit()}
          />
        </div>
      )}
    </Formik>
  )
}

export default FormTailorMade
